/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS')
  .factory('ZcsOemService', zcsOemService);

zcsOemService.$inject = ['$q', '$translate', 'ZcsMakerepeaterOem'];
function zcsOemService($q, $translate, ZcsMakerepeaterOem) {
  class ZcsOemService {

    static set(oemService) {
      this.oemService = oemService;
    }

    static get() {
      return this.oemService;
    }

    static isOemService() {
      return !!this.oemService;
    }

    static getName() {
      switch (this.oemService) {
        case 'makerepeater': return $translate.instant('services.zcsOem.makerepeater');
        default: return 'AiDeal lite';
      }
    }

    static getConversionTagPrefix() {
      switch (this.oemService) {
        case 'makerepeater': return 'mrcvassist';
        default: return 'zenclerk';
      }
    }

    static getPublishHostForProject(project) {
      switch (this.oemService) {
        case 'makerepeater': return 'cvtr.makerepeater.jp';
        default: return `${project.publish_domain}.zenclerk.com`;
      }
    }

    static handleLogin() {
      switch (this.oemService) {
        case 'makerepeater':
          return ZcsMakerepeaterOem.handleLogin();
        default:
          return $q.reject();
      }
    }

    static providePublicApi() {
      switch (this.oemService) {
        case 'makerepeater':
          return ZcsMakerepeaterOem.providePublicApi();
      }
    }
  }
  return ZcsOemService;
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/zcs_oem.service.js